module.exports = __webpack_public_path__ + "static/img/vuejs-fill.0ff1d6c7.svg";